import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const RadioContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: ${pxToRem('6px')};
  padding: ${props => (props.padding ? `${props.padding}` : 'unset')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${({ disabled, readonly }) =>
    disabled &&
    !readonly &&
    css`
      cursor: not-allowed;
    `};

  ${({ readonly, theme }) =>
    readonly &&
    css`
      pointer-events: none;
      border: none;
      background-color: ${theme.colors.transparent};
    `};
`;

export const IconDecline = styled.span`
  width: ${pxToRem('18px')};
  height: ${pxToRem('18px')};
  border-radius: 100%;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.semantic.secondary};
  cursor: pointer;
  font-size: ${pxToRem('10px')};
  padding: ${pxToRem('5px')};
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const IconAccept = styled.span`
  width: ${pxToRem('18px')};
  height: ${pxToRem('18px')};
  border-radius: 100%;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.semantic.tertiary};
  cursor: pointer;
  font-size: ${pxToRem('16px')};
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const RadioItem = styled.div`
  display: flex;
  position: relative;
  margin-bottom: ${pxToRem('8px')};
  cursor: pointer;
`;
export const Text = styled.div`
  width: 100%;
`;

export const ValidRadio = styled.span`
  position: absolute;
  font-size: ${pxToRem('35px')};
  font-weight: 700;
  top: 50%;
  right: ${pxToRem('5px')};
  color: ${({ theme }) => theme.colors.semantic.tertiary};
  transform: translate(0, -50%);
`;

export const RadioButtonLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: ${pxToRem('8px')};
  height: ${pxToRem('8px')};
  border-radius: 50%;
  border: ${pxToRem('2px')} solid ${props => props.theme.colors.blue.one};
  margin-right: ${pxToRem('19px')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: ${pxToRem('2px')} ${pxToRem('2px')} ${pxToRem('4px')} 0
    rgba(0, 0, 0, 0.08);
  padding: ${pxToRem('6px')};
  ${props =>
    props.checked &&
    css`
      background-image: linear-gradient(135deg, #7cb2fd, #467afb);
      color: ${props.theme.colors.white};
    `}
`;

export const Radio = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 50%;
  margin-right: ${pxToRem('10px')};
  width: ${pxToRem('10px')};
  height: ${pxToRem('10px')};
  cursor: pointer;

  ${({ readonly }) =>
    readonly &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;
export const ActionButton = styled.div`
  display: flex;
  padding-bottom: ${pxToRem('6px')};
  span:first-child {
    margin-right: ${pxToRem('10px')};
  }
`;
